/* eslint-disable @typescript-eslint/no-explicit-any */
import { NextRouter } from 'next/router';
import { DiscoveryBlock, DiscoveryItem } from '@teko/discovery';
import { parseJsonStringSafely } from '@teko/utils';
export {
  getObjFromQueryString,
  isValidEmailFormat,
  isValidPhoneFormat,
} from '@teko/utils';
import { formatCurrency as libFormatCurrency } from '@teko/ds-desktop';

declare global {
  interface Window {
    MSStream: any;
  }
}

export const formatCurrency = (
  money: number | string,
  isFull = true,
): string => {
  return libFormatCurrency(money, { hideCurrencySymbol: !isFull });
};

export const saveRecentlyProduct = (sku: string, localKey: string): void => {
  const historyStorage = localStorage.getItem(localKey);
  if (!historyStorage) {
    localStorage.setItem(localKey, JSON.stringify([sku]));
    return;
  }
  let histories: string[] = parseJsonStringSafely(
    historyStorage,
    [],
  ) as string[];
  histories = histories.filter((item: string) => item !== sku);
  histories = [sku, ...histories];
  if (histories.length > 20) {
    histories.pop();
  }
  localStorage.setItem(localKey, JSON.stringify(histories));
};

export const isIOSDevice = () => {
  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  return iOS;
};
export const isAndroidDevice = () => {
  const android = /(android)/i.test(navigator.userAgent);
  return android;
};
// Check if path equals ...
export const checkPathEqual = (router: NextRouter, path: string): boolean => {
  let pathname = router.asPath || router.pathname;
  pathname === '' ? '/' : pathname;
  const searchParam = pathname.indexOf('?');
  pathname = searchParam >= 0 ? pathname.substring(0, searchParam) : pathname;
  const rawPath =
    path.indexOf('?') >= 0 ? path.substring(0, path.indexOf('?')) : path;
  return pathname === rawPath;
};

// Check if path includes ...
export const checkPathInclude = (
  router: NextRouter,
  acceptedPaths: string[],
) => {
  const pathName = router.asPath || router.pathname;
  return acceptedPaths.some((path) => pathName.includes(path));
};

export const checkExpiryDateTimestamp = (
  startDate: string,
  endDate: string,
): boolean => {
  const today = new Date().getTime();
  if (
    today - new Date(parseInt(startDate) * 1000).getTime() > 0 &&
    new Date(parseInt(endDate) * 1000).getTime() - today > 0
  )
    return true;
  return false;
};

export const isHomepage = (pathname: string): boolean => {
  // Old version
  // return ['', '/'].includes(pathname);
  // This's added for supporting multi-languages
  return !pathname || /^\/(\?lang=[a-zA-Z-]{2,5})?$/.test(pathname);
};

export const filterBlockItems = (
  item: DiscoveryItem,
  blockList: DiscoveryBlock[],
): boolean => {
  const matchFormat = item.url.match(/^#\d+$/);
  if (!matchFormat) return false;
  const blockId = item.url.substring(1);
  const block = blockList.find((e) => e.id === blockId);
  if (!block) return false;
  return true;
};

export const getBaseDomain = () => {
  if (typeof window === 'undefined') return '';
  return `${window?.location?.protocol}/${window?.location?.host}`;
};
